(() => {
  const initVerticalThumbnailGalleries = () => {
    document.querySelectorAll('.ero-thumbnail-slider').forEach((gallery) => {
      if (gallery.dataset.eroThumbReady === 'true') return;
      gallery.dataset.eroThumbReady = 'true';

      const list = gallery.querySelector('.thumbnail-list');
      const controls = gallery.querySelectorAll('[data-ero-thumb-direction]');
      if (!list || !controls.length) return;

      const getStep = () => {
        const firstItem = list.querySelector('.thumbnail-list__item');
        if (!firstItem) return 96;
        const styles = getComputedStyle(list);
        const gap = parseFloat(styles.rowGap || styles.gap || '0') || 0;
        return firstItem.getBoundingClientRect().height + gap;
      };

      const update = () => {
        const max = Math.max(0, list.scrollHeight - list.clientHeight);
        controls.forEach((button) => {
          const direction = Number(button.dataset.eroThumbDirection || 0);
          const atStart = list.scrollTop <= 1;
          const atEnd = list.scrollTop >= max - 1;
          button.classList.toggle('is-muted', direction < 0 ? atStart : atEnd);
          button.setAttribute('aria-disabled', String(direction < 0 ? atStart : atEnd));
        });
      };

      controls.forEach((button) => {
        button.addEventListener('click', () => {
          const direction = Number(button.dataset.eroThumbDirection || 0);
          list.scrollBy({ top: direction * getStep(), behavior: 'smooth' });
          window.setTimeout(update, 320);
        });
      });

      list.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update, { passive: true });
      update();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVerticalThumbnailGalleries);
  } else {
    initVerticalThumbnailGalleries();
  }

  document.addEventListener('shopify:section:load', initVerticalThumbnailGalleries);
})();
